import { StyleDeclarationValue } from 'aphrodite';
import { CustomPageType } from '../../../extViewmodels/sdk/models/CustomPageStyle';
import { useCustomPageStyle } from '../../hooks/useCustomPageStyle';
import { MeetingContainerView } from './MeetingContainerView';

interface IProps {
	cardStyles?: StyleDeclarationValue[];
	className?: string;
	contentStyles?: StyleDeclarationValue[];
	styles?: StyleDeclarationValue[];
	shortCode?: string;
	children: React.ReactNode;
}

export const MeetingContainer: React.FC<IProps> = ({
	cardStyles = [],
	children,
	className = '',
	contentStyles = [],
	styles = [],
	shortCode,
}) => {
	const {
		data: customHeaderData,
		hasCustomContent: hasCustomHeader,
		inIframe,
	} = useCustomPageStyle(shortCode, CustomPageType.Header);
	const { data: customFooterData, hasCustomContent: hasCustomFooter } = useCustomPageStyle(
		shortCode,
		CustomPageType.Footer
	);

	return (
		<MeetingContainerView
			cardStyles={cardStyles}
			className={className}
			contentStyles={contentStyles}
			customFooterHtml={inIframe ? undefined : customFooterData?.html}
			customHeaderHtml={inIframe ? undefined : customHeaderData?.html}
			hasCustomFooter={hasCustomFooter}
			hasCustomHeader={hasCustomHeader}
			styles={styles}
		>
			{children}
		</MeetingContainerView>
	);
};
